import { FormBuilder, Validators } from '@angular/forms';
import { onlyNumbers } from '../../../../shared/utils/validate-number';
export var availableItemFields = {
    type: 'type',
    urlComparisonType: 'urlComparisonType',
    text: 'text',
    time: 'time',
    percent: 'percent',
    pages: 'pages',
    page: 'page'
};
var ItemService = /** @class */ (function () {
    function ItemService(fb) {
        var _a;
        this.fb = fb;
        this.formFields = (_a = {},
            _a[availableItemFields.type] = ['', Validators.required],
            _a[availableItemFields.urlComparisonType] = ['', Validators.required],
            _a[availableItemFields.text] = ['', [Validators.required, Validators.pattern('.*[^ ].*')]],
            _a[availableItemFields.time] = ['', [Validators.required, onlyNumbers]],
            _a[availableItemFields.percent] = ['', [Validators.required, onlyNumbers, Validators.min(0), Validators.max(100)]],
            _a[availableItemFields.pages] = [[], [Validators.required]],
            _a[availableItemFields.page] = ['', [Validators.required, Validators.pattern('.*[^ ].*')]],
            _a);
    }
    ItemService.prototype.createForm = function (fieldsWithData) {
        var _this = this;
        var form = this.fb.group({});
        Object.keys(fieldsWithData).forEach(function (field) {
            var _a;
            _this.addField(form, (_a = {},
                _a[field] = fieldsWithData[field],
                _a));
        });
        return form;
    };
    ItemService.prototype.addField = function (form, field) {
        var key = Object.keys(field)[0];
        if (!form.get(key)) {
            if (field[key] instanceof Array) {
                form.addControl(key, this.prepareArray(field));
            }
            else {
                var validators = this.formFields[key][1];
                form.addControl(key, this.fb.control(field[key], validators));
            }
        }
    };
    ItemService.prototype.prepareArray = function (field) {
        var _this = this;
        var key = Object.keys(field)[0];
        var arrayForm = this.fb.array([]);
        field[key].forEach(function (element) {
            arrayForm.push(_this.createGroupItem(element));
        });
        return arrayForm;
    };
    ItemService.prototype.createGroupItem = function (field) {
        var _a;
        var formFieldType = Object.keys(field)[0];
        var validators = this.formFields[formFieldType][1];
        return this.fb.group((_a = {},
            _a[formFieldType] = [field[formFieldType], validators],
            _a));
    };
    return ItemService;
}());
export { ItemService };
